import { render, staticRenderFns } from "./CarTypeField.vue?vue&type=template&id=29517808&scoped=true"
import script from "./CarTypeField.vue?vue&type=script&lang=ts"
export * from "./CarTypeField.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29517808",
  null
  
)

export default component.exports